import { apiEndpoint } from '@/settings/env';
const API_URL = apiEndpoint;
// http://parenteral.tegra.com.br:8080

const ENDPOINTS = {
  // Login
  LOGIN: '/login',  
  FORGOT_PASSWORD_INIT: '/logins/esqueci-senha',
  FORGOT_PASSWORD_UUID_INIT: '/logins/esqueci-senha/uuid',
  FORGOT_PASSWORD_VALID: '/logins/esqueci-senha/validacao',
  FORGOT_PASSWORD_JUSTIF_INATIV: '/logins/esqueci-senha/justificar-inatividade',
  FORGOT_PASSWORD_DEFINE: '/logins/esqueci-senha/definicao',
  LOGIN_PRE_ACTIVATION_UUID_INIT: '/logins/pre-efetivacao/uuid',
  LOGIN_PRE_ACTIVATION_DOCS: '/logins/pre-efetivacao/documentos',
  LOGIN_GEO_AREAS: '/logins/areas-geograficas',

  // Login - Validação celular
LOGIN_CELLPHONE_VALIDATION: '/logins/celulares/validacoes',
LOGIN_CELLPHONE_VALIDATION_POSTPONE: '/logins/celulares/validacoes/adiamentos',

  // biometria
  WEBAUTHN_REGISTRATION: '/webauthn/registros',
  WEBAUTHN_PRE_AUTHENTICATION: '/webauthn/autenticacoes',
  WEBAUTHN_AUTHENTICATION: '/webauthn/login',
  // Unidades empresariais
  BUSINESS_UNITS: '/empresas',
  BUSINESS_UNITS_USER: '/empresas/unidades',
  BUSINESS_UNITS_STATUS: '/empresas/todas',
  BUSINESS_UNITS_FILE: '/imagem',
  // SIEVES (Crivos)
  SIEVES: '/propriedade',
  SIEVE: '/propriedade',
  SIEVES_TYPES: '/operadores/tipos',
  // Access Groups
  DEFAULT_ACCESS_GROUPS: '/grupos/copia',
  ACCESS_GROUPS: '/grupos',
  ACCESS_GROUP: '/grupos',
  // Access Profiles
  PROFILES: '/perfis',  
  PROFILES_FEATURES: '/perfis/{tipo}/recursos',
  PROFILES_PROFILES_ACCESS: '/perfis/{tipo}/perfis-acesso',
  USERS: '/usuarios',
  USERS_LEADERS: '/usuarios/lideres',
  USERS_GEO_AREAS: '/usuarios/areas-geograficas',
  USERS_SUBORDINATES: '/usuarios/liderados',
  USERS_PROFILES: '/usuarios/perfis',
  USERS_LOGIN_TYPES: '/usuarios/tipos-login',
  USER_SESSION_DATA: '/logins/dados/sessao',
  USER_LOGGED: '/usuarios/dados',
  USER_DOCS_ANALYSIS: '/usuarios/analises/docs',
  USER_PRE_ACTIVATION_EMAIL: '/usuarios/pre-efetivacao/email',
  USER_STATUS_ACTIVATION_OPTIONS: '/usuarios/efetivacoes/situacoes',
  // Measurement Units
  MEASUREMENT: '/v2/unit-of-measurement',
  // Ativos/Insumo
  MATERIALS: '/v2/insumo',
  MATERIAL: '/v2/insumo',
  MATERIALS_CLASSIFICATIONS: '/v2/insumo/classificacao',
  // PRODUTOS
  PRODUCTS: '/produtos',
  PRODUCTS_TP_PATIENT_CONFIGS: '/produtos/tipos-pacientes/configs',
  PRODUCTS_FILE: '/educativo',
  PRODUCT_CALORIES: '/produtos/calorias',
  PRODUCT_MULTI_UNITS_CONVERSION: '/produtos/medidas/v2',
  PRODUCT_MULTI_UNITS_ENTERAL_CONVERSION: '/produtos/medidas/enteral',
  // Grupos (produtos)
  GROUPS: '/grupo',
  GROUP: '/grupo',
  GROUP_ORDER: '/grupos/produtos/ordem',
  // Subgrupo (produtos)
  SUBGROUPS: '/subgrupo',
  SUBGROUPS_PRODUCTS_OPTIONS: '/subgrupo/produtos/opcoes',
  SUBGROUP: '/subgrupo',
  // Médicos
  DOCTORS: '/medicos',
  DOCTORS_COMBO: '/medicos/combo',
  CFM_INFORMATIONS: '/medicos/cfm',
  // Clientes
  CLIENTS: '/clientes',
  // Unidades de cliente
  UNIDADE_CLIENTE: '/unidade',
  UNIDADE_CLIENTE_IMAGEM: '/imagem',
  UNIDADE_CLIENTE_SETORES: '/setores',
  UNIDADE_CLIENTE_TEMPLATES: '/templates',
  UNIDADE_CLIENTE_REPORT_XLS: '/unidade/xls',
  UNIDADE_CLIENTE_OPC_BOLSA_MULTI: '/unidade/bolsamulticompart/opcoes',
  UNIDADE_CLIENTE_DIAS_BOLSA_MULTI: '/unidade/bolsamulticompart/dias-semana',
  UNIDADE_CLIENTE_TIPOS_AGEND_PROD: '/unidade/tipos-agendamentos-producao',
  CLIENT_UNIT_PRODUCTS_OPTIONS: '/unidade/produtos',

  // Pacientes
  PATIENT: '/pacientes',
  PATIENT_LATEST: '/pacientes/mais-atual',
  PATIENT_MERGE: '/pacientes/agrupamentos',
  PATIENT_LIST_PAGINATION: '/pacientes/pagina',
  PATIENT_EXIST_CLIENTS: '/pacientes/existentes/clientes',
  PATIENT_TYPE: '/pacientes/tipo-paciente',
  PATIENT_IMC: '/pacientes/imc',
  
  // Prescrição
  PRESCRIPTION: '/prescricoes',
  PRESCRIPTION_UUID: '/prescricoes/uuid',
  PRESCRIPTION_STATUS: '/prescricoes/status',
  PRESCRIPTION_PRODUCTS: '/prescricoes/{id}/produtos',
  PRESCRIPTION_PRODUCTS_OPTIONS: '/prescricoes/produtos',
  PRESCRIPTION_V2: '/prescricoes/v2',
  TRANSCRIPTION: '/transcricao',
  TRANSCRIPTION_PRESCRIPTION: '/transcricao/prescricao',
  TRANSCRIPTION_INIT: '/transcricao/inicia',
  TRANSCRIPTION_DISCART: '/transcricao/descarta',
  TRANSCRIPTION_CANCEL: '/transcricao/cancela',
  PRESCRIPTION_MODELS_COMBO: '/prescricoes/modelos/combo',
  PRESCRIPTION_TEMPLATES: '/prescricoes/templates',
  PRESCRIPTION_ENTERALS: '/prescricoes/enterais',
  PRESCRIPTION_VALIDATE: '/prescricoes/validar',
  PRESCRIPTION_VALIDATION_V2: '/prescricoes/validacao/v2',  
  PRESCRIPTION_RESUME: '/prescricoes/resumo',
  PRESCRIPTION_RESUME_V2: '/prescricoes/resumo/v2',
  PRESCRIPTION_CLIENT_APROVATION: '/prescricoes/aprova/cliente',
  PRESCRIPTION_EMEDE_APROVATION: '/prescricoes/aprova',
  PRESCRIPTION_PREAPPROVAL_VALIDATION: '/prescricoes/{id}/aprovacao/validacao',
  PRESCRIPTION_EMEDE_APROVATION_SCHEDULE: '/prescricoes/aprova/agenda/',
  PRESCRIPTION_EMEDE_APROVATION_SCHEDULE_MULTI: '/prescricoes/aprova/agenda/multi',
  PRESCRIPTION_EMEDE_APROVATION_SCHEDULE_DETAILS: '/prescricoes/aprova/agenda/detalhes',
  PRESCRIPTION_DELETE_GROUP: '/prescricoes/exclusao/{id}/grupo',
  PRESCRIPTION_ALTER_GROUP: '/prescricoes/alteracao/{id}/grupo',
  PRESCRIPTION_LOCK_GROUP: '/prescricoes/bloqueio/{id}/grupo',
  PRESCRIPTION_UNLOCK_GROUP: '/prescricoes/desbloqueio/{id}/grupo',
  PRESCRIPTION_LOCK: '/prescricoes/bloqueio',
  PRESCRIPTION_UNLOCK: '/prescricoes/desbloqueio',
  PRESCRIPTION_HIST: '/prescricoes/historicos',
  PRESCRIPTION_HIST_XLS: '/prescricoes/historicos/xls',
  PRESCRIPTION_HIST_PDF: '/prescricoes/historicos/pdf',
  PRESCRIPTION_HIST_PRODUCTS: '/prescricoes/historicos/produtos',
  PRESCRIPTION_HIST_PRODUCTS_COMBO: '/prescricoes/historicos/produtos/combo',
  PRESCRIPTION_HIST_PRODUCTS_XLSX: '/prescricoes/historicos/produtos/xlsx',
  TRANSCRIPTION_APROVATION: '/transcricao/aprova',
  TRANSCRIPTION_OCR: '/transcricao/ocr',
  TRANSCRIPTION_OCR_CONFER: '/transcricao/ocr/{id}/conferencia',
  PRESCRIPTION_CANCEL: '/prescricoes/cancela',
  TEMPLATE: '/templates',
  TEMPLATE_COMBOBOX: '/templates/combo',
  TEMPLATE_PREVIEW: '/templates/{id}/previsualizar',
  TEMPLATE_MULTICOMP_OPTIONS: '/templates/compartimentados/modelos',
  TEMPLATE_VALIDATION: '/templates/validacao',
  TEMPLATE_PRODUCTS: '/templates/prescricao',
  TEMPLATE_RECALC: '/templates/prescricao/recalcula',
  PRESCRIPTION_REPORT: '/relatorio/prescricao/token',
  PRESCRIPTION_REPORT_TOKEN: '/relatorio/prescricao/token',
  PRESCRIPTION_THERAPIES: '/prescricoes/terapias',
  PRESCRIPTION_SIMPLE_THERAPY: '/prescricoes/terapias/simplificadas',
  PRESCRIPTION_SIMPLE_THERAPY_AVAILABLE: '/prescricoes/terapias/simplificadas/disponivel',
  PRESCRIPTION_TYPES: '/prescricoes/tipos',
  PRESCRIPTION_DELIVERY_DATES: '/prescricoes/datas-entrega',
  PRESCRIPTION_ADDRESS: '/prescricoes/pacientes',
  PRESCRIPTION_CLIENT_UNITS: '/prescricoes/clientes/unidades',
  PRESCRIPTION_PATIENTS_COMBO: '/prescricoes/unidades/{idUnidade}/pacientes/combo',

  // Prescrição - Rascunho
  PRESCRIPTION_DRAFT: '/prescricoes/rascunhos',

  // Planos de saúde
  HEALTH_INSURANCE: '/v2/convenio',
  HEALTH_INSURANCE_BY_CLIENT: '/v2/convenio/unidade',
  // Parametros
  PARAMETERS: '/parametrizacao',
  PARAMETERS_FILES: '/parametrizacao/arquivos',
  PARAMETERS_OVERRIDE: '/parametrizacao/hierarquia/filtro',
  CANCELLATION_REASONS: '/parametrizacao/tipo/MOTIVO_CANCELAMENTO',
  ALTER_PRESCRIPTION_REASONS: '/parametrizacao/tipo/MOTIVO_ALTER_PRESCRICAO',
  LOCK_PRESCRIPTION_REASONS: '/parametrizacao/tipo/MOTIVO_BLOQUEIO_PRESCRICAO',
  SCHEDULING_LIMIT: '/parametrizacao/tipo/DIAS_AGENDAMENTO',
  EXPIRATION_TIME: '/parametrizacao/tipo/TEMPO_INATIVIDADE',
  INFUSION_TIME: '/parametrizacao/tipo/TEMPO_INFUSAO',
  // Expressões
  EXPRESSION: '/expressao',
  // Motor de regras
  RULES_ENGINE: '/restricoes',
  RULES_ENGINE_ALTER_HIST: '/restricoes/{id}/alteracoes',
  RULES_ENGINE_STATUS: '/restricoes/{id}/status',
  RULES_ENGINE_OVERRIDE: '/restricoes/hierarquias',
  RULES_ENGINE_CONDITIONS: '/condicao',
  RULES_ENGINE_OPERATORS: '/operadores',
  RULES_ENGINE_ENTITY: '/entidadeConfiguravel',
  //Regras - Relatorios
  RULES_ENGINE_REPORT: '/restricoes/relatorios',
  RULES_ENGINE_REPORT_XLS: '/restricoes/relatorios/xls',
  // TIMES
  TEAM: '/time',
  TEAM_COMBO: '/time/combo',
  // Status de serviços
  SIPRO_SERVICE: '/expressao',
  SIPRO_DATABASE: '/expressao',
  // UTILS
  UTILS_DATETIME: '/utils/datahora',
  UTILS_ERROR_LOG: '/utils/logs/erros',
  UTILS_IS_PRODUCTION: '/utils/producao',
  // Bolsas Compartimentadas - Modelos
  BAG_MODELS_PRODUCTS: '/bolsas/modelos/produtos',
  BAG_MODELS: '/bolsas/modelos',
  // Bolsas Compartimentadas - Config
  SPLITTED_BAG_CONFIG: '/bolsas-multi/configuracoes',
  SPLITTED_BAG_CONFIG_WEEKDAYS: '/bolsas-multi/configuracoes/dias-semana',
  // Terapia:
  THERAPY: '/terapias',
  THERAPY_INIT: '/terapias/inicial',
  THERAPY_VOLUME_UNITS: '/terapias/volumes/unidades-medidas',
  // Terapia/Farmo Express:
  SIMPLE_THERAPY: '/terapias/simplificadas',
  SIMPLE_THERAPY_PRODUCTS: '/terapias/simplificadas/produtos',
  SIMPLE_THERAPY_CLINICS_SITUATIONS: '/terapias/simplificadas/situacoes-clinicas',
  SIMPLE_THERAPY_NPTS: '/terapias/simplificadas/npts',
  SIMPLE_THERAPY_CLIENTS: '/terapias/simplificadas/clientes',
  SIMPLE_THERAPY_TN_DAYS: '/terapias/simplificadas/diastn',
  SIMPLE_THERAPY_NUTRITION_OFFERS: '/terapias/simplificadas/ofertas-nutricionais',
  SIMPLE_THERAPY_VALID_UNITCLIENT_PROD: '/terapias/simplificadas/unidades/produtos/acessos',
  SIMPLE_THERAPY_ACTIVE_THERAPIES: '/terapias/simplificadas/terapias/ativas',
  // Estados Clinicos
  CLINIC_STATES_ACTIVE: 'estados-clinicos/ativos',
  CLINIC_STATES: 'estados-clinicos',
  // Situacoes Clinicas
  CLINIC_SITUATIONS: 'situacoes-clinicas',  
  // Grupo Enteral:
  ENTERAL_GROUP: '/enteral/grupos',
  ENTERAL_PRODUCT: '/enteral/produtos',
  ENTERAL_PRODUCT_GROUPS: '/enteral/produtos/grupos/ativos',
  ENTERAL_PRODUCT_MAKERS: '/enteral/produtos/fabricantes',

  // Relatorio Usuários:
  USERS_REPORT: '/usuarios/relatorios',
  USERS_REPORT_PROFILES: '/usuarios/relatorios/perfis',
  USERS_REPORT_USER_TYPES: '/usuarios/relatorios/tipos-login',
  USERS_REPORT_XLS: '/usuarios/relatorios/xls',
  USERS_REPORT_PDF: '/usuarios/relatorios/pdf',
  
  // Relatorio Unidades Clientes:
  CLIENT_UNITS_REPORT: '/unidades/relatorios',
  CLIENT_UNITS_REPORT_XLS: '/unidades/relatorios/xls',  
  
  // Dashboard
  BUSINESS_UNIT_DASHBOARD: '/dashboard/empresas',
  PRODUCTION_PRESCRIPTION_CHART_DATA: '/dashboard/prescricoes/producao/tipos',
  STATUS_PRESCRIPTION_CHART_DATA: '/dashboard/prescricoes/situacoes',
  USERS_TRANSCRIPTION_CHART_DATA: '/dashboard/transcricoes/usuarios',  
  USERS_WRONG_TRANSCRIPTION_CHART_DATA: '/dashboard/transcricoes/usuarios/erradas',  
  USERS_APPROVAL_CHART_DATA: '/dashboard/prescricoes/aprovadas/usuarios',
  NEW_LOST_PATIENT_CHART_DATA: '/dashboard/pacientes/novos-perdidos',
  DASHBOARD_PATIENTS_PRESCR_MONITORING: '/dashboard/pacientes/acompanhamentos',
  
  // Notificacoes
  NOTIFICATION: '/notificacoes',
  NOTIFICATION_IMAGE: '/notificacoes/imagens',
  NOTIFICATION_PROFILE: '/notificacoes/perfis',
  NOTIFICATION_BUSINESS_UNIT: '/notificacoes/empresas',
  NOTIFICATION_TYPES: '/notificacoes/tipos',
  NOTIFICATION_LOGINS_NOTIFIED: '/notificacoes/logins/notificados',
  NOTIFICATION_LOGINS_CREATOR: '/notificacoes/logins/inclusao',
  NOTIFICATION_LOGINS: '/notificacoes/logins',
  NOTIFICATION_CLIENTS_UNITS: '/notificacoes/unidades',
  NOTIFICATION_TEAMS: '/notificacoes/times',
  NOTIFICATION_READING: '/notificacoes/leituras',
  NOTIFICATION_READING_PAGE: '/notificacoes/leituras/pagina',

  // Whatsapp
  WHATSAPP_SCHEDULE: '/whatsapps/agendamentos',

  // Pendencias Prescricao
  PENDING_PRESCRIPTIONS: '/prescricoes/pendencias',
  PENDING_PRESCRIPTIONS_STATUSES_FILTER: '/prescricoes/pendencias/statuses/filtro',
  PENDING_PRESCRIPTIONS_STATUSES_EDIT: '/prescricoes/pendencias/statuses/alteracao',
  PENDING_PRESCRIPTIONS_WHATSAPP: '/prescricoes/pendencias/whatsapp',
  PENDING_PRESCRIPTIONS_WHATSAPP_VARIABLES: '/prescricoes/pendencias/{id}/whatsapp/variaveis',

    // Relatorio Usuários:
  ALERTS_PRESCRIPTIONS_REPORT: '/prescricoes/alertas/relatorios',
  ALERTS_PRESCRIPTIONS_REPORT_XLS: '/prescricoes/alertas/relatorios/xls',
  ALERTS_PRESCRIPTIONS_REPORT_PRODUCTS: '/prescricoes/alertas/relatorios/produtos',
  ALERTS_PRESCRIPTIONS_REPORT_CODES: '/prescricoes/alertas/relatorios/codigos',
  
  // Solicitação de Proposta de Frete
  SHIPPING_QUOTE_CLIENT_UNITS: '/propostas-frete/solicitacoes/unidades',
  SHIPPING_QUOTE_REQUEST: '/propostas-frete/solicitacoes',
  SHIPPING_QUOTE_STATUSES: '/propostas-frete/situacoes',
  SHIPPING_QUOTE_USERS: '/propostas-frete/solicitantes',
  SHIPPING_QUOTE_PATIENTS: '/propostas-frete/pacientes',
  SHIPPING_QUOTE_CLIENTUNITS: '/propostas-frete/unidades',
  SHIPPING_QUOTE_ANALISE: '/propostas-frete/analises',

  // Relatorio Usuários:
  CLIENT_UNITS_PRODUTS_REPORT: '/unidades/produtos/relatorios',
  CLIENT_UNITS_PRODUTS_REPORT_XLS: '/unidades/produtos/relatorios/xls',
  CLIENT_UNITS_PRODUTS_REPORT_PRODUCTS: '/unidades/produtos/relatorios/produtos',

  // Relatório Prescrições por Prescritores
  PRESCRIPTOR_PRESCRIPTIONS_REPORT: '/prescricoes/prescritores/relatorios',
  PRESCRIPTOR_PRESCRIPTIONS_REPORT_XLS: '/prescricoes/prescritores/relatorios/xls',

    // PDFs das Prescrições do Mês
  PRESCRIPTIONS_MONTH_PDFS: '/prescricoes/pdfs/mes',
  PRESCRIPTIONS_MONTH_PDFS_FORMATS: '/prescricoes/pdfs/mes/formatos',
  PRESCRIPTIONS_MONTH_PDFS_MONTHS: '/prescricoes/pdfs/mes/meses',
  

  // Endereços de Entrega
  DELIVERY_ADDRESS: '/enderecos/entrega',
  DELIVERY_ADDRESS_BLOCK: '/enderecos/entrega/bloqueios',
  DELIVERY_ADDRESS_UNBLOCK: '/enderecos/entrega/desbloqueios',
  DELIVERY_ADDRESS_HIST: '/enderecos/entrega/{ids}/historicos',
  
  // Relatório Prescrições por Endereço
  ADDRESS_PRESCRIPTIONS_REPORT: '/prescricoes/enderecos/relatorios',
  ADDRESS_PRESCRIPTIONS_REPORT_XLS: '/prescricoes/enderecos/relatorios/xls',

  // CRM - Instituição
  CRM_INSTITUTION: '/crm/instituicoes',
  CRM_INSTITUTION_COMBO: '/crm/instituicoes/combo',
  CRM_INSTITUTION_VISITORS_COMBO: '/crm/instituicoes/visitantes/combo',
  CRM_INSTITUTION_CONTACTS_COMBO: '/crm/instituicoes/contatos/combo',
  CRM_INSTITUTION_VISIT_CONTACTS_COMBO: '/crm/instituicoes/contatos/visitas/combo',
  CRM_INSTITUTION_CONTATO: '/crm/instituicoes/{id}/contatos',
  CRM_INSTITUTION_CLIENT_DETAILS: '/crm/instituicoes/clientes/{id}',
  CRM_INSTITUTION_PROSPECT_DETAILS: '/crm/instituicoes/prospects/{cnpj}',
  CRM_INSTITUTION_QUALIFICATIONS: '/crm/instituicoes/qualificacoes',
  CRM_INSTITUTION_NP_SUPPLIERS: '/crm/instituicoes/np-fornecedores',
  CRM_INSTITUTION_RTUS: '/crm/instituicoes/rtus',
  CRM_INSTITUTION_PATIENT_TYPES: '/crm/instituicoes/tipos-paciente',
  CRM_INSTITUTION_ACTIVATION: '/crm/instituicoes/ativacao',
  CRM_INSTITUTION_CHART_PRESCR_TP_PATIENT: '/crm/instituicoes/indicadores/bolsas/tipo-paciente',
  CRM_INSTITUTION_SYNC_GEO_AREAS: '/crm/instituicoes/areas-geo/sincronizacoes',
  CRM_INSTITUTION_CHART_PRESCR_DOCTORS: '/crm/instituicoes/indicadores/bolsas/medicos',

  // CRM - Contato
  CRM_CONTACT: '/crm/contatos',
  CRM_CONTACT_BY_FIELD: '/crm/contatos/campo',
  CRM_CONTACT_COMBO: '/crm/contatos/combo',
  CRM_CONTACT_ACTIVATION: '/crm/contatos/ativacao',
  CRM_CONTACT_HIERARCHIES: '/crm/contatos/hierarquias',
  CRM_CONTACT_POSITIONS: '/crm/contatos/funcoes',

  // CRM - Agendamento de Visita
  CRM_VISIT_PLANNING: '/crm/visitas/agendamentos',
  CRM_VISIT_PLANNING_INSTITUTIONS: '/crm/visitas/agendamentos/instituicoes/{id}',
  CRM_VISIT_PLANNING_USER_CYCLE: '/crm/visitas/agendamentos/ciclo-planejamento',
  CRM_VISIT_PLANNING_VISITORS: '/crm/visitas/agendamentos/visitantes/combo',
  CRM_VISIT_PLANNING_CONTACTS: '/crm/visitas/agendamentos/contatos/combo',

  // CRM - Registro de Visita
  CRM_VISIT_REGISTRATION: '/crm/visitas/registros',
  CRM_VISIT_REGISTRATION_INSTITUTIONS: '/crm/visitas/registros/instituicoes/{id}',  
  CRM_VISIT_REGISTRATION_PLANNING_INSTITUTION: '/crm/visitas/registros/agendamentos/instituicoes/{id}',  
  CRM_VISIT_REGISTRATION_PLANNING: '/crm/visitas/registros/agendamentos/{id}',  
  CRM_VISIT_REGISTRATION_VISITORS: '/crm/visitas/registros/visitantes/combo',  
  CRM_VISIT_REGISTRATION_CONTACTS: '/crm/visitas/registros/contatos/combo',  

  // CRM - Ciclo de Planejamento
  CRM_PLANNING_CYCLE: '/crm/ciclos-planejamentos',

  // CRM - Calendário
  CRM_CALENDAR: '/crm/visitas/calendario',
  CRM_CALENDAR_VISITORS_COMBO: '/crm/visitas/calendario/visitantes/combo',  
  CRM_CALENDAR_CONFLICTS: '/crm/visitas/calendario/conflitos',  

  // CRM - Dashboard
  CRM_DASHBOARD_CONFIGS: '/crm/dashboard/configs',
  CRM_DASHBOARD_GEOAREAS: '/crm/dashboard/areas-geograficas',
  CRM_DASHBOARD_VISITORS: '/crm/dashboard/visitantes/combo',
  CRM_DASHBOARD_KPIS: '/crm/dashboard/indicadores',
  CRM_DASHBOARD_KPIS_VISITORS: '/crm/dashboard/indicadores/consultores',
  CRM_DASHBOARD_ADM_KPIS_VISITORS: '/crm/dashboard/indicadores/consultores/adm',
  CRM_DASHBOARD_KPIS_VISITORS_DAYS: '/crm/dashboard/indicadores/consultores/dias',
  CRM_DASHBOARD_ADM_KPIS_VISITORS_DAYS: '/crm/dashboard/indicadores/consultores/dias/adm',
  CRM_DASHBOARD_KPIS_VISITORS_DAYS_AVG: '/crm/dashboard/indicadores/consultores/dias/medias',
  CRM_DASHBOARD_KPIS_INSTITUTIONS: '/crm/dashboard/indicadores/instituicoes',
  CRM_DASHBOARD_ANALYTICS: '/crm/dashboard/indicadores/analiticos',

  // CRM - Evolução de Visitas
  CRM_VISIT_EVOLUTION_VISITORS_OPTIONS: '/crm/visitas/evolucao/visitantes/combo',
  CRM_VISIT_EVOLUTION: '/crm/visitas/evolucao',
  CRM_VISIT_EVOLUTION_VISITORS: '/crm/visitas/evolucao/consultores',

  // CRM - Evolução das Instituicoes
  CRM_INSTITUTION_EVOLUTION: '/crm/instituicoes/evolucao',
  CRM_INSTITUTION_EVOLUTION_MONTHS: '/crm/instituicoes/evolucao/meses',

  // CRM - Agenda
  CRM_PLANNER_ITEM_TYPES: '/crm/agenda/itens/tipos',
  CRM_PLANNER_ITENS: '/crm/agenda/itens',

  // Endereço
  ADDRESS_CEP: '/enderecos/ceps',
  ADDRESS_CITIES: '/enderecos/municipios/{uf}',

  // Pessoa Fisica
  INDIVIDUALS: '/pessoas/fisicas',
  INDIVIDUALS_COMBO: '/pessoas/fisicas/combo',

  // Calendário - Feriados
  CALENDAR_HOLIDAYS: '/calendarios/feriados',

  // Controle processamentos
  ASYNC_PROCESS: '/processamentos',

};

export { API_URL, ENDPOINTS };
